import { MenuItem, Position } from "@blueprintjs/core";
import { Suggest } from "@blueprintjs/select";
import React, { useEffect, useState } from "react";
import { API_BASE_SZAKKEPZES } from "../../utils/routes";
import style from "../szakkepzes/KKK/KKK.module.scss";

const SuggestQualification = ({
  onSelect, // callback, signature: (item, event) => {}
}) => {
  const [qualifications, setQualificaitons] = useState([]);

  useEffect(() => {
    getQualifs();
  }, []);

  const getQualifs = async () => {
    fetch(API_BASE_SZAKKEPZES + "/qualifications")
      .then((res) => res.json())
      .then((jsonarr) => {
        console.log(jsonarr);
        setQualificaitons(jsonarr.map((q) => ({ name: q.name, id: q.id })));
      });
  };

  const itemRenderer = (item, { handleClick, modifiers, query }) => (
    <MenuItem
      key={item.id}
      text={item.name}
      onClick={handleClick}
      active={modifiers.active}
    />
  );

  const filterQualifications = (query, qualif, _index, exactMatch) => {
    const normalizedName = qualif.name.toLowerCase();
    const normalizedQuery = query.toLowerCase();
    if (exactMatch) {
      return normalizedName === normalizedQuery;
    } else {
      return normalizedName.indexOf(normalizedQuery) >= 0;
    }
  };

  return (
    <Suggest
      items={qualifications}
      itemRenderer={itemRenderer}
      inputValueRenderer={(item) => item.name}
      noResults={<MenuItem disabled={true} text="Nincs találat" />}
      onItemSelect={onSelect}
      popoverProps={{
        popoverClassName: style.qualifselectPopover,
        position: Position.BOTTOM_LEFT,
      }}
      itemPredicate={filterQualifications}
      inputProps={{ required: true, placeholder: "Válasszon..." }}
    />
  );
};

export default SuggestQualification;
